import { STATUS_OPTIONS } from "./types";

export function StatusBadge({ statuses, onClick }: { statuses: string[]; onClick?: () => void }) {
    const displayText = statuses.length === 1 ? statuses[0] : statuses.length === STATUS_OPTIONS.length - 1 ? "All" : `${statuses.length} Selected`;

    return (
        <div
            className="bg-[#85c2c2] flex gap-2.5 items-center justify-center px-2 py-0.5 rounded-full cursor-pointer hover:opacity-90 transition-opacity"
            onClick={onClick}
        >
            <p className="font-inter font-normal text-xs text-white whitespace-nowrap">{displayText}</p>
        </div>
    );
}
